<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <div class="row">
          <div class="col-md-6 col-sm-12">
            <label for>Name</label>
            <input
              type="text"
              class="form-control"
              disabled
              :value="property.name"
            />
          </div>
          <div class="col-md-6 col-sm-12">
            <label for>Country</label>
            <select class="form-control" disabled>
              <option selected>
                {{ countryName(property.country) }}
              </option>
            </select>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-md-5 col-12">
            <div>
              <label for>City</label>
              <input
                type="text"
                class="form-control"
                disabled
                :value="property.address ? property.address.city : ''"
              />
            </div>
          </div>
          <div class="col-md-5 col-12">
            <div>
              <label for>Street</label>
              <input
                type="text"
                class="form-control"
                disabled
                :value="property.address ? property.address.street : ''"
              />
            </div>
          </div>
          <div class="col-md-2 col-sm-12">
            <label for>ZIP</label>
            <input
              type="text"
              class="form-control"
              disabled
              :value="property.address ? property.address.zip : ''"
            />
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-md-4 col-12">
            <div>
              <label for>Building Name</label>
              <input
                type="text"
                class="form-control"
                disabled
                :value="property.address ? property.address.buildingName : ''"
              />
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div>
              <label for>Registry Number</label>
              <input
                type="text"
                class="form-control"
                disabled
                :value="property.address ? property.address.registryNumber : ''"
              />
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div>
              <label for>Additional</label>
              <input
                type="text"
                class="form-control"
                disabled
                :value="property.address ? property.address.additional : ''"
              />
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-md-12 col-sm-12">
            <label for>Description</label>
            <textarea
              cols="30"
              rows="10"
              class="form-control"
              disabled
              :value="property.address ? property.address.description : ''"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCountryName } from "@/app-assets/js/get-countries.js";
export default {
  props: ["property"],

  methods: {
    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },
  },

  mounted() {},
};
</script>

